import cloneDeep from 'lodash/cloneDeep';

import StaffSelectPanel from 'src/components/staff-select-panel';
import GroupSelectPanel from 'src/components/group-select-panel';
import RobotSelectPanel from 'src/components/robot-select-panel';
import NavRouteSelectPanel from 'src/components/nav-route-select-panel';
import OrganizationTree from 'src/pages/srv/wpaWx/wpaWxAccess/edit/components/preview-edit/organizationTree';
import DistributeRuleTemplateSelect from './components/distribute-rule-select';
import conf from './conf';

// 自助导航默认值
const DEFAULT_NAVROUTER = {
    routerList: [],
    defaultNav: {},
};

const DEFAULT_NAVROBOT = {};

// 不点击导航，设置无响应时，默认返回值
const NO_RESPONSE_DATA = '请点击导航';

// 不点击导航，直接发送消息默认值
const DEFAULT_SUBNAV = {
    value: -1,
    data: NO_RESPONSE_DATA,
    receptionSwitch: 1,
};

export default {
    components: {
        StaffSelectPanel,
        GroupSelectPanel,
        RobotSelectPanel,
        NavRouteSelectPanel,
        OrganizationTree,
        DistributeRuleTemplateSelect,
    },

    props: {
        // 旧版和新版WPA创建统一使用一套代码实现，version用来区分新旧版本
        version: {
            type: Number,
            default: 2,
        },
        showRobotNav: {
            type: Boolean,
            default: true,
        },
        value: {
            type: Object,
            default: () => {},
        },

        initData: {
            type: Object,
            default: () => ({
                robotList: [],
                roleIM: {},
            }),
        },

        // 是否判断主号对外接待
        isCheckKfuin: {
            type: Boolean,
            default: false,
        },
        isRoute: {
            type: Boolean,
            default: false,
        },

        // 接待配置选项
        config: {
            type: Object,
            default: () => ({
                [conf.MANUAL_NONE]: true,
                [conf.MANUAL_SINGLE]: true,
                [conf.MANUAL_GROUP]: true,
                [conf.MANUAL_ROBOT]: true,
                [conf.MANUAL_OLD_NAV]: false,
                [conf.MANUAL_NAV]: true,
                [conf.MANUAL_RULE]: true,
                [conf.MANUAL_LEAVE]: true,
            }),
        },
    },

    data() {
        const cacheValue = {
            [conf.MANUAL_NONE]: {},
            [conf.MANUAL_SINGLE]: {},
            [conf.MANUAL_GROUP]: {},
            [conf.MANUAL_ROBOT]: {
                robotNav: {},
            },
            [conf.MANUAL_OLD_NAV]: {},
            [conf.MANUAL_ROUTE]: {},
            [conf.MANUAL_NAV]: {
                navRouter: {
                    routerList: [],
                    defaultNav: {},
                },
                subNav: {
                    value: -1,
                    data: NO_RESPONSE_DATA,
                },
            },
            [conf.MANUAL_RULE]: {
                value: 6,
            },
            [conf.MANUAL_LEAVE]: {
                value: 7,
            },
            [conf.MANUAL_INDEPENDENT_SINGLE]: {
                value: 7,
            },
        };

        let curRadioValue = -1;
        if (typeof this.value.value !== 'undefined') {
            curRadioValue = +this.value.value;
        }
        const data = cloneDeep(window.pageData.data);
        const isHasRule = !!(data && data.isHasRule);

        return {
            curRadioValue,

            // 数据层级简化

            // 机器人设置相关
            // 当前选择机器人
            robotItem: null,
            // 机器人列表数据
            robotList: this.initData.robotList,
            // 默认导航的信息
            defaultNav: cloneDeep(DEFAULT_NAVROUTER).defaultNav,
            // 自助导航设置相关
            // 0-不分时段 1-分时段
            timeType: 0,
            // 自助导航列表
            navRouter: cloneDeep(DEFAULT_NAVROUTER),
            // 不点击导航，直接发送消息设置
            subNav: cloneDeep(DEFAULT_SUBNAV),
            // 不点击导航，设置无响应时，返回值
            noResponseData: NO_RESPONSE_DATA,

            // 缓存数据
            cacheValue,

            isShowStaffSelectPanel: false,
            isShowGroupSelectPanel: false,
            isShowRobotSelectPanel: false,
            isShowNavRouteSelectPanel: false,
            isShowRobitNavSelectPanel: false,
            // 高级分配规则
            isShowDistributeRulePanel: false,
            data,
            isHasRule,

            // 机器人导航相关
            robotNav: this.initData.robotNav || {},

            // 是否展示错误验证消息
            isShowErrors: {
                [conf.MANUAL_SINGLE]: false,
                [conf.MANUAL_GROUP]: false,
                [conf.MANUAL_ROBOT]: false,
                [conf.MANUAL_NAV]: false,
                [conf.MANUAL_RULE]: false,
                [conf.MANUAL_INDEPENDENT_SINGLE]: false,
            },
        };
    },

    computed: {
        // 单机器人/多机器判断
        isSingleRobot() {
            return this.robotList.length === 1;
        },

        // 自助导航配置(自助导航列表、不点击导航，直接发送消息设置)
        selfNavValue() {
            return {
                navRouter: this.navRouter,
                subNav: this.subNav,
            };
        },

        // 机器人导航配置
        robotNavValue() {
            return {
                robotNav: this.robotNav || {},
            };
        },
    },

    watch: {
        value(nextValue) {
            if (typeof nextValue.value !== 'undefined') {
                this.curRadioValue = +nextValue.value;
            }
            this.init(nextValue);
        },
        robotNav: {
            deep: true,
            handler(newValue) {
                this.robotNavValue.robotNav = newValue;
            },
        },
    },

    created() {
        this.init(this.value);
    },

    methods: {
        init(value) {
            this.isShowErrors[conf.MANUAL_ROBOT] = false;
            this.cacheValue[value.value] = cloneDeep(value);
            const key = this.cacheValue[value.value].uin || this.cacheValue[value.value].id;
            this.cacheValue[value.value].uin = key;
            this.cacheValue[value.value].id = key;
            console.log('211111', this.value, this.cacheValue[value.value]);

            // 创建/编辑机器人时，区分单机器人和多机器人情况
            if (this.curRadioValue === conf.MANUAL_ROBOT) {
                if (this.cacheValue[conf.MANUAL_ROBOT].uin) {
                    if (this.robotList.length === 1) {
                        // 当前选中的机器人已经不在可选的机器人列表里，而新的机器人列表只有1个机器人可选时，
                        // 将选中的机器人插入机器人列表，设置机器人状态为无效，保证用户可以选择另一个机器人
                        const id = this.robotList[0].robotId || this.robotList[0].id;
                        if (id != +this.cacheValue[conf.MANUAL_ROBOT].uin) {
                            this.robotList.unshift({
                                robotIcon: '',
                                robotName: this.cacheValue[conf.MANUAL_ROBOT].name,
                                robotId: +this.cacheValue[conf.MANUAL_ROBOT].uin,
                                robotStatus: 2,
                                robotReason: '机器人无权限',
                                robotTips: '请配置新的机器人',
                                noSelect: true,
                            });

                            [this.robotItem] = this.robotList;
                        } else {
                            [this.robotItem] = this.robotList;
                        }
                    } else {
                        // eslint-disable-next-line max-len
                        this.robotItem = this.robotList.find(item => item.robotId === +this.cacheValue[conf.MANUAL_ROBOT].uin)
                            || null;
                    }
                } else if (this.robotList.length === 1) {
                    [this.robotItem] = this.robotList;
                }
                console.log('cache', this.cacheValue[conf.MANUAL_ROBOT]);

                const { robotNav } = this.cacheValue[conf.MANUAL_ROBOT];

                if (!robotNav) {
                    this.cacheValue[conf.MANUAL_ROBOT].robotNav = cloneDeep(DEFAULT_NAVROBOT);
                }
                if (robotNav) {
                    if (robotNav.defaultNav && robotNav.defaultNav.FID) {
                        this.robotNav = cloneDeep(value.robotNav);
                    } else {
                        this.robotNav = cloneDeep(robotNav);
                    }
                }
            }

            // 创建/编辑自助导航时
            if (this.curRadioValue === conf.MANUAL_NAV) {
                const { navRouter, subNav } = this.cacheValue[conf.MANUAL_NAV];

                if (!navRouter) {
                    this.cacheValue[conf.MANUAL_NAV].navRouter = cloneDeep(DEFAULT_NAVROUTER);
                }
                if (!subNav) {
                    this.cacheValue[conf.MANUAL_NAV].subNav = cloneDeep(DEFAULT_SUBNAV);
                }

                if (navRouter && navRouter.defaultNav && navRouter.defaultNav.id) {
                    this.navRouter = cloneDeep(value.navRouter);
                    this.subNav = cloneDeep(value.subNav);

                    // 判断是不分时段/分时段导航
                    if (this.navRouter.routerList && this.navRouter.routerList.length > 0) {
                        this.timeType = 1;
                    }
                }
            }
            if (value.receptionSwitch !== undefined) {
                this.subNav = value;
            }
            let val = true;
            if (this.$store) {
                this.$store.commit('routerIsHasRule', { val });
                if (this.curRadioValue === 6) {
                    val = this.isHasRule;
                    this.$store.commit('routerIsHasRule', { val });
                }
            }
        },

        setSelectTreePopper() {
            this.$refs.organizationTree.show(this.$refs.setSelectTreeTrigger);
        },

        confirmTree(value) {
            this.cacheValue[this.curRadioValue] = {
                ...this.cacheValue[this.curRadioValue],
                isDisabled: 0,
                name: `${value[0].name}（${value[0].id}）`,
                id: value[0].id,
                uin: value[0].id,
                data: value[0].id,
            };
            this.onChange(false);
        },

        checkRobotInvalid(robotItem) {
            if (!robotItem) return false;
            return robotItem.robotStatus === 2;
        },

        onPickGroup() {
            this.isShowGroupSelectPanel = true;
            if (this.$refs.groupSelectorPanelNew) {
                this.$refs.groupSelectorPanelNew.show();
            }
        },

        onPickStaff() {
            this.isShowStaffSelectPanel = true;
        },

        onPickRobot() {
            this.isShowRobotSelectPanel = true;
        },

        onPickNavRoute() {
            this.isShowNavRouteSelectPanel = true;
        },
        // 点击修改按钮, 机器人导航列表显示
        onPickRobotNavRoute(value) {
            this.isShowRobitNavSelectPanel = true;
            console.log('原本的导航id是');
            console.log(value);
        },
        // 点击高级分配规则
        onPickDistributeRule() {
            this.isShowDistributeRulePanel = true;
        },

        onChange(needValidate = false) {
            const data = { ...this.cacheValue[this.curRadioValue] };
            this.isShowErrors[conf.MANUAL_ROBOT] = false;
            if (this.curRadioValue === conf.MANUAL_NAV) {
                data.subNav = this.subNav;
                data.navRouter = this.navRouter;
            }

            if (this.curRadioValue === conf.MANUAL_NONE) {
                data.data = NO_RESPONSE_DATA;
            }
            if (this.curRadioValue === conf.MANUAL_ROBOT) {
                data.robotNav = {};
                data.robotNav.robotNavMenuSwitch = this.robotNav.robotNavMenuSwitch ? 1 : 0;
                data.robotNav.robotNavMenuId = this.robotNav.robotNavMenuId;
                data.robotNav.defaultNav = this.robotNav.defaultNav;
            }

            this.$emit('change', data);

            if (needValidate) this.validate();
        },

        onRoleChange(value) {
            this.curRadioValue = value;
            this.cacheValue[this.curRadioValue].value = this.curRadioValue;
            this.isShowErrors[conf.MANUAL_ROBOT] = false;
            if (this.curRadioValue === conf.MANUAL_ROBOT) {
                // 单机器人时不展示选择机器人弹框，直接选中当前机器人
                if (this.robotList.length === 1) {
                    const robot = this.robotList[0];

                    // 当前选中的机器人已经不在可选的机器人列表里
                    if (
                        this.cacheValue[conf.MANUAL_ROBOT].uin
                        && robot.robotId !== +this.cacheValue[conf.MANUAL_ROBOT].uin
                    ) {
                        return;
                    }

                    this.onSelectChange({
                        ...robot,
                        id: robot.robotId,
                        name: robot.robotName,
                    });
                    return;
                }
            }

            this.onChange();
        },

        onSelectChange(value) {
            // eslint-disable-next-line no-new
            this.cacheValue[this.curRadioValue] = {
                ...this.cacheValue[this.curRadioValue],
                isDisabled: 0,
                name: value.name,
                id: value.id,
                uin: value.id,
                data: value.id,
            };

            // 选择机器人需要额外设置当前选中的机器人
            if (this.curRadioValue === conf.MANUAL_ROBOT) {
                this.robotItem = value;
                // 额外设置当前机器人导航列表
                console.log(value);
                this.robotNav = value;
                this.cacheValue[this.curRadioValue].robotNav = value;
                this.robotNav.defaultNav = {};
            }

            // 选择自助导航需要额外设置当前自助导航列表
            if (this.curRadioValue === conf.MANUAL_NAV) {
                this.navRouter = value;
                this.cacheValue[this.curRadioValue].navRouter = value;
            }

            // 高级分配规则
            if (this.curRadioValue == conf.MANUAL_RULE) {
                this.distributeInfo = value;
            }

            this.onChange(false);
        },
        // 机器人导航列表选中之后
        onSelectRobotChange(value) {
            this.cacheValue[this.curRadioValue] = {
                ...this.cacheValue[this.curRadioValue],
            };
            value.robotNavMenuSwitch = this.robotNav.robotNavMenuSwitch || '';
            this.robotNav = value;
            console.log(value);
            // 导航id存储
            this.robotNav.robotNavMenuId = value.defaultNav.FID;
            this.cacheValue[this.curRadioValue].robotNav = this.robotNav;
            this.onChange(true);
        },

        onSubNavChange(val) {
            const receptionSwitch = this.subNav.receptionSwitch !== undefined ? this.subNav.receptionSwitch : 1;
            this.subNav = val;
            this.subNav.receptionSwitch = receptionSwitch;
            this.cacheValue[this.curRadioValue].subNav = val;
            this.cacheValue[this.curRadioValue].subNav.receptionSwitch = receptionSwitch;
            this.onChange();
        },

        onNavSwitchChange(value) {
            if (!this.subNav) {
                this.subNav = {};
            }
            this.subNav.receptionSwitch = value;
            this.cacheValue[this.curRadioValue].subNav.receptionSwitch = value;
            this.onChange();
        },
        // 机器人导航点击允许下发
        onRobotNavChange(value) {
            if (!this.robotNav) {
                this.robotNav = {};
            }
            this.robotNav.robotNavMenuSwitch = value;
            this.cacheValue[this.curRadioValue].robotNav = this.robotNav;
            this.onChange();
        },
        /**
         * 验证组件输出数据是否正确
         */
        validate() {
            let ret = true;
            const item = this.cacheValue[this.curRadioValue];
            switch (this.curRadioValue) {
            case conf.MANUAL_INDEPENDENT_SINGLE:
            case conf.MANUAL_SINGLE:
            case conf.MANUAL_GROUP:
                if (!item.uin || item.isDisabled) {
                    ret = false;
                }
                break;
            case conf.MANUAL_ROBOT:
                if (this.robotList.length > 1) {
                    if (!item.uin) {
                        ret = false;
                    }
                }
                if (this.robotNav) {
                    if (this.robotNav.robotNavMenuSwitch && !this.robotNav.robotNavMenuId) {
                        ret = false;
                    }
                }
                break;
            case conf.MANUAL_NAV:
                try {
                    if (!item.navRouter.defaultNav.id) {
                        ret = false;
                    }
                    // 部分编辑场景下，如微信客服，server不会返回subNav.uin数据，因此增加subNav.data判断
                    if (item.subNav.value !== undefined && item.subNav.value !== -1 && (!(+item.subNav.uin) && !(+item.subNav.data))) {
                        ret = false;
                    }

                    if (this.$refs.selfNavSelect && !this.$refs.selfNavSelect.validate()) {
                        ret = false;
                    }
                } catch (err) {
                    ret = false;
                }
                break;

            case conf.MANUAL_RULE:
                ret = !this.showDistributeTip;
                break;
                // no default
            }

            this.isShowErrors[this.curRadioValue] = !ret;
            return ret;
        },
    },
};
